import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Firebase
import { db } from '../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, onSnapshot, orderBy, startAfter, limit } from 'firebase/firestore';

import mixpanel from 'mixpanel-browser';

// Redux
import { connect } from 'react-redux';

// Actions
import { setPage, add_To_Recent_History, toggleAuthModal } from '../actions/navActions';
import { getPopularSearches, set_ShowBottomSpinner } from '../actions/searchActions';

// Layout Wrapper
import Layout from '../components/layout/Layout';
import Spinner from '../components/common/Spinner';
import replaceHyphenWithSpace from '../utils/reusable_functions/replace_Hyphens_With_Space';
import { CATEGORY_LIST } from '../utils/constant_variables/CATEGORIES_LIST';

// Icons
import SearchIcon from '@material-ui/icons/Search';
import SignalCellularAltOutlinedIcon from '@material-ui/icons/SignalCellularAltOutlined';
import { HorizontalNav } from '../components/common/HorizontalNav';

const PopularSearchesPage = ({ 
    setPage, 
    add_To_Recent_History,
    match, 
    search: {
        popular_searches,
        popular_loading,
        no_more_searches,
        show_bottom_spinner,
        last_page_doc
    },
    auth,
    nav: {
        website,
        website_loading
    },
    getPopularSearches,
    set_ShowBottomSpinner
}) => {

    // State variable to track if Mixpanel event has been sent
    const [sentMixpanel, setSentMixpanel] = useState(false);

    // Window width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // -- Inifite scroll --

    // Temporarily disable to load more function to avoid duplicate fetch requests
    const [canLoadMore, setCanLoadMore] = useState(true);
    // Scroll direction - for displaying top nav bar
    const [scrollDirection, setScrollDirection] = useState("up");
    const [oldScrollY, setOldScrollY] = useState(window.scrollY);

    // -- END: Inifite scroll --

    const [searchList, setSearchList] = useState([]);

    // Get the current URL and extract the "redirect" parameter
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    const hostname = window.location.hostname;
    const search_tag = match.params.search_tag?.toLowerCase();

    // Determine window size breakpoints
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;

    // Listen for window resize event and update window width state
    useEffect(() => {

        // Set the current page
        setPage('popular searches');
        add_To_Recent_History(url.pathname);  // current url

        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Clean up by removing event listener on component unmount
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // -- Get initial categories list --

    useEffect(() => {
        getPopularSearches({});

    }, []);

    // -- END: Get initial categories list --

    useEffect(() => {

        renderSearchesList();

    }, [ popular_searches, popular_loading, canLoadMore ]);

    // Handle top nav bar display
    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target

        const newScrollY = offsetHeight + scrollTop;

        // --- Handle top nav bar display
        if(isMobile) {
            if(oldScrollY < newScrollY){

                // scrolling down - hide top nav
                setScrollDirection("down");
    
                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.remove("active");
                }
                
            } else {
    
                // scrolling up - show top nav
                setScrollDirection("up");
    
                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.add("active");
                }
            }
        }
        // --- END Handle top nav bar display

        // update the scroll position for future comparison
        setOldScrollY(newScrollY)

        // Check if the user has scrolled to the bottom of the content and conditions for loading more notifications are met
        if (newScrollY >= scrollHeight - 1 && !show_bottom_spinner && !no_more_searches && popular_searches.length > 0 && canLoadMore) {
            console.log('scrolling');
            loadMore(last_page_doc);
        }
    }

    // Function to load more paginated notifications
    const loadMore = async (lastPage_doc) => {
        console.log('Loading more categories');

        try {
            // Temporarily disable to load more function to avoid duplicate fetch requests
            setCanLoadMore(false);
            // Show spinner
            set_ShowBottomSpinner(true);

            if(!website_loading) {
                getPopularSearches({ lastPageDoc: lastPage_doc })
            }
        } catch (error) {
            console.log("ERROR loading more", error);
        } finally {
            // Re-enable the load more capabilty
            setCanLoadMore(true);
        }

    }

    // Handles Mixpanel tracking
    const handleMixpanel = () => {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_ID);

        // Track event
        mixpanel.track("Categories Page View");
    }

    // Checks if the environment is production and Mixpanel tracking hasn't been sent
    if(process.env.NODE_ENV === 'production' && !sentMixpanel && !hostname.includes('xbuysell')) {
        // Call Mixpanel tracking function
        handleMixpanel();
        // Set Mixpanel event as sent
        setSentMixpanel(true);
    }

    const renderSearchesList = async () => {
        setSearchList([]);

        if(popular_loading) {
            setSearchList([(
                <div className="no-rides">
                    <Spinner />
                </div>
            )])
        }
        else { 
            if(popular_searches.length > 0) {
                popular_searches.map(popular_search => {
                    setSearchList(searchList => [...searchList, (
                        <div onClick={() => window.location = `/search?q=${popular_search.text}`} className="search-dropdown-item less_y_padding" key={popular_search._id}>
                            <div className='search_dropdown_item_icon'>
                                <SearchIcon />
                            </div>
                            <div className='search_dropdown_item_option'>
                                <div className='generated_result'>
                                    <span>
                                        
                                    </span>
                                    <span>
                                        {popular_search.text}
                                    </span>
                                </div>
                                <div className='search_stats'>
                                    {popular_search.total_views}
                                    <SignalCellularAltOutlinedIcon />
                                </div>
                            </div>
                        </div>
                    )])
                }) 
            } else {
                setSearchList(userList => [...userList, (
                    <div className="no-rides">
                        <h1>No categories found</h1>
                    </div>
                )])
                
            }
        } 
    }

    return (
        <Fragment>
            <Layout handleScroll={handleScroll} page="popular searches">
                {popular_searches.length > 0 && (
                    <div className='menu-title' style={{display: 'flex', justifyContent:'space-between', alignItems: 'center', padding: '12px 16px'}}>
                        <div style={{lineHeight:'24px', fontSize:'20px', fontWeight:700, wordWrap:'break-word', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>
                            <span>Popular searches</span>
                        </div>
                    </div>
                )}
                                
                {searchList}

                {/* Render a spinner at the bottom if there are more notifications to load */}
                {show_bottom_spinner && !no_more_searches && !popular_loading && <Spinner />}

                {/* Display a message when there are no more notifications */}
                <div className="no-rides" style={{minHeight: '400px', justifyContent: 'start', paddingTop: '50px'}}>{(no_more_searches && popular_searches.length !== 0) && "You've reached the end."}</div>
            </Layout>
        </Fragment>
    )
}

PopularSearchesPage.propTypes = {
    auth: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired,
    search: PropTypes.object.isRequired, // Object prop representing the group state
    setPage: PropTypes.func.isRequired, // Function prop to set the current page in the navigation
    add_To_Recent_History: PropTypes.func.isRequired,
    getPopularSearches: PropTypes.func.isRequired,
    set_ShowBottomSpinner: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    search: state.search,
    auth: state.auth,
    nav: state.nav
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    setPage, 
    add_To_Recent_History,
    getPopularSearches,
    set_ShowBottomSpinner
})(PopularSearchesPage);
